/**
 * @desc 财务画像--公司信息部分
 * @author caoyx
 */
import styles from './companyInfo.scss';
import companyDefaultJPG from '../../../../images/companyDefault.jpg';
import React, { PureComponent } from 'react';
import { hashHistory } from 'react-router';
import cns from 'classnames';
import { Icon } from 'antd';
import { COMPANY_INFO_SESSION } from '../../../../constants/common';
import { RiskFraudType } from '../../../../constants/enum';
import { RiskFraudTypeText } from '../../../../constants/info';
import { remove, setSession } from '../../../../utils/storage';
import messager from '../../../../utils/messager';
import { isEmpty } from '../../../../utils/util';
import { queryCompanyInfo } from '../../../../services/financialPicture/common';
import { addCollection, cancelCollection } from '../../../../services/personalCollect';
import { commonRequest, checkSearch } from '../commons';
import FeedbackModal from './FeedbackModal';
import { generateReport } from '../../../../services/report';

export default class CompanyInfo extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showFeedbackModal: false,
            companyData: {},
            collecting: false,
            fraudReportSpin: false,
            riskReportSpin: false
        };
    }

    componentDidMount() {
        remove(COMPANY_INFO_SESSION); // 先清除缓存的公司信息
        this.publicCompany();
    }

    publicCompany = () => {
        queryCompanyInfo(commonRequest()).then(data => {
            data = data || {};
            this.setState({
                companyData: data
            });
            setSession(COMPANY_INFO_SESSION, data);
        });
    };

    // 收藏公共的传参数据
    collectionFormData = () => {
        const { companyCode, reportYear, reportType, reportDateType } = checkSearch();

        return {
            companyCode,
            reportYear,
            reportType,
            reportDateType,
            stockCode: companyCode
        };
    };

    // 收藏操作
    toggleCollect = (e) => {
        e.stopPropagation();
        const { companyData, collecting } = this.state;
        if (isEmpty(companyData)) {
            return messager.info('暂无数据');
        }
        if (collecting) {
            return;
        }
        const { collect, collectId } = companyData;
        let server = collect ? cancelCollection : addCollection;
        let param = collect ? { id: collectId } : this.collectionFormData();
        let message = collect ? '取消收藏成功' : '收藏成功';

        this.setState({
            collecting: true
        });
        server(param).then(() => {
            messager.success(message);
            companyData.collect = !collect;
            this.setState({
                companyData,
                collecting: false
            });
            this.publicCompany();
        }).catch(() => {
            this.setState({
                collecting: false
            });
        });
    };

    // 生成报告
    creatReport = e => {
        let { companyCode, reportYear, reportType, reportDateType } = checkSearch();
        let type = e.target.getAttribute('data-type').toUpperCase();
        let typeCode = RiskFraudType[type];
        let typeText = RiskFraudTypeText[typeCode];
        let spinField = type === 'FRAUD' ? 'fraudReportSpin' : 'riskReportSpin';

        if (this.state[spinField]) { // 避免重复请求
            return;
        }

        this.setState({
            [spinField]: true
        });

        generateReport({
            companyCode,
            generateReportType: typeCode,
            reportYear,
            reportType,
            reportDateType
        }).then(() => {
            messager.success(`${typeText}报告已生成！可在个人中心-历史报告中查看`);
        }).finally(() => {
            this.setState({
                [spinField]: false
            });
        });
    };

    // 反馈
    handleFeedback = () => {
        // messager.info('此功能暂未开发，尽情期待！');
        this.setState({
            showFeedbackModal: true
        });
    };

    // Modal回调方法，关闭Modal
    modalCallback = () => {
        this.setState({
            showFeedbackModal: false
        });
    };

    /**
     * @desc 锚点：查看详情
     * @param {Event} e 事件
     */
    showDetailJump = e => {
        const anchorId = e.target.getAttribute('data-anchorId');
        const { companyInfo } = hashHistory.getCurrentLocation().query;
        hashHistory.replace(`/cwhx/sy/gs?companyInfo=${companyInfo}&anchorId=${anchorId}`);
    };

    render() {
        const { className } = this.props;
        const { showFeedbackModal, companyData, collecting, fraudReportSpin, riskReportSpin } = this.state;
        const btnClass = companyData.collect ? 'btn-orange' : 'btn-primary';
        let fraudDisable = companyData.fraudScore ? false : true,
            riskDisable = companyData.riskScore ? false : true;
        return (
            <div className={cns(styles.companyInfo, className)}>
                <div className={cns(styles.imgBox, 'clearfix')}>
                    <img src={companyDefaultJPG} alt="企业图"/>
                </div>
                <div className={styles.item}>
                    <div className={styles.name}>{companyData.compname || '--'}</div>
                    <div>
                        <i className="iconfont icon-hangye" />
                        {companyData.csrclevel1NAME || '--'}
                    </div>
                    <div>
                        <span>
                            <i className="iconfont icon-pingfen" />
                            财务造假评分：
                            <span className={cns(styles.valueBox, 'red-font')}>
                                {companyData.fraudScore || '--'}
                            </span>
                        </span>
                        <span>
                            <i className="iconfont icon-yujing" />
                            风险预警提示：
                            <span className={cns(styles.valueBox, 'red-font')}>
                                {companyData.fraudWarnTotal || '--'}项
                            </span>
                        </span>
                        {/* 财务造假锚点 */}
                        <a className={styles.showDetail} data-anchorId="fraud" onClick={this.showDetailJump}>
                            查看详情
                        </a>
                        <a
                            className={styles.riskReport}
                            data-type="fraud"
                            disabled={fraudDisable}
                            onClick={this.creatReport}
                        >
                            财务造假报告
                            {fraudReportSpin && <Icon type="loading" spin />}
                        </a>
                    </div>
                    <div>
                        <span>
                            <i className="iconfont icon-pingfen" />
                            财务风险评分：
                            <span className={cns(styles.valueBox, 'red-font')}>
                                {companyData.riskScore || '--'}
                            </span>
                        </span>
                        <span>
                            <i className="iconfont icon-yujing" />
                            风险预警提示：
                            <span className={cns(styles.valueBox, 'red-font')}>
                                {companyData.riskWarnTotal || '--'}项
                            </span>
                        </span>
                        {/* 财务风险锚点 */}
                        <a className={styles.showDetail} data-anchorId="risk" onClick={this.showDetailJump}>
                            查看详情
                        </a>
                        <a
                            className={styles.riskReport}
                            disabled={riskDisable}
                            data-type="risk"
                            onClick={this.creatReport}
                        >
                            财务风险报告
                            {riskReportSpin && <Icon type="loading" spin />}
                        </a>
                    </div>
                </div>
                <div className={cns(styles.btnBox)}>
                    <button className={cns(styles.collect, 'btn', btnClass)} onClick={this.toggleCollect}>
                        {companyData.collect ? '已收藏' : '收藏'}
                        {collecting && <Icon type="loading" spin />}
                    </button>
                    {/* <button className="btn btn-orange" onClick={this.handleFeedback}>
                        反馈
                    </button> */}
                </div>
                <div>
                    {showFeedbackModal && (
                        <FeedbackModal isVisible={showFeedbackModal} modalCallback={this.modalCallback} />
                    )}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/common/companyInfo/CompanyInfo.jsx